import React from 'react'

export const IndianFlagIcon: React.FC = () => (
  <svg width="32" height="22" viewBox="0 0 32 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="22" fill="#FF9933"/>
    <rect y="7.33" width="32" height="7.34" fill="#FFFFFF"/>
    <rect y="14.67" width="32" height="7.33" fill="#138808"/>
    <circle cx="16" cy="11" r="3.5" fill="#000080"/>
  </svg>
)
export const PalmTreeIcon : React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
<path d="M19.991 35.4117C23.499 25.5007 21.9355 17.7845 18.8906 14.9414H20.8699C26.499 19.5007 23.8456 30.0897 25.499 35.0007L19.991 35.4117Z" fill="#434141"/>
<path d="M12.0328 25.3642C14.2125 19.4341 18.2318 16.0289 19.7992 15.0518L33.0021 17.0361C30.1765 11.5338 25.4857 11.8219 22.815 12.4258C25.5582 8.9916 29.3965 7.41194 31.1431 6.77459C24.1204 3.72204 21.4864 7.63517 20.4353 10.4181C18.9181 3.2968 13.2224 2.68513 8.76163 4.54418C14.5616 7.51894 16.4702 10.0989 16.7172 11.5338C10.3228 7.96433 5.79243 11.9436 4.82043 15.0518C8.64303 13.9353 13.9292 14.059 16.1716 14.3914C8.76163 16.4412 10.5967 22.6681 12.0328 25.3642Z" fill="#43B941"/>
<path d="M22.7734 12.4321C23.8567 10.977 27.0481 7.80108 31.1478 6.73828C28.8387 6.93604 23.9312 8.35167 22.7734 12.4321Z" fill="#257424"/>
<path d="M19.7605 15.0632C15.6382 17.8661 12.7355 22.9587 12.0391 25.258C13.2689 18.8251 17.5179 15.0098 19.4886 13.9062L33.0477 17.0595L19.7605 15.0632Z" fill="#257424"/>
<path d="M4.83594 15.0403C6.79935 14.4809 11.8187 13.5726 16.1889 14.4151C13.9842 13.6034 8.62698 12.592 4.83594 15.0403Z" fill="#257424"/>
<path d="M8.84375 4.55664C11.2603 5.59404 16.0637 8.8364 16.8525 11.6542C17.0295 9.93357 15.6756 6.10514 8.84375 4.55664Z" fill="#257424"/>
<path d="M31.415 37.4938H10.0546C9.57991 37.4938 9.28274 36.9861 9.54382 36.5896C12.5967 31.9535 17.6217 30.9218 19.8715 31.0078C25.9289 30.8151 30.0669 34.2296 31.8919 36.5895C32.1885 36.973 31.8997 37.4938 31.415 37.4938Z" fill="#FFDB97"/>
</svg>
)
export const Clock48Icon: React.FC = () => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.65 24.17c2.307 9.137 11.029 14.107 19.788 12.546 8.638-1.54 13.213-10.068 10.905-19.203-2.31-9.137-10.54-15.626-19.266-13.887C3.105 5.615-.657 15.032 1.65 24.17"
      fill="#68a2ff"
    />
    <path
      d="M5.266 23.152c1.851 7.325 8.843 11.311 15.865 10.058 6.926-1.233 10.595-8.07 8.744-15.397-1.851-7.325-8.451-12.527-15.445-11.13-7.997 1.593-11.014 9.144-9.164 16.469"
      fill="#fff"
    />
    <path
      d="m18.88 29.303.268 2.99M16.263 8.084l.268 2.99m12.079 7.028-2.352.322m-17.57 1.639-2.364.22"
      stroke="#f7b92a"
      strokeWidth={1.102}
      strokeLinecap="round"
    />
    <path
      d="m12.053 23.077-.12-1.032 2.481-5.156.86-.1.172 1.47-.525.06-1.67 3.48.007.057 4.243-.494.124 1.067zm3.572.932-.191-1.644-.04-.463-.588-5.059 1.224-.142.833 7.164zm5.83-.579q-.78.09-1.415-.101a2.3 2.3 0 0 1-1.028-.607 1.7 1.7 0 0 1-.457-1 1.7 1.7 0 0 1 .1-.852 1.86 1.86 0 0 1 .465-.692q.313-.295.725-.414l-.006-.05a1.53 1.53 0 0 1-.96-.458 1.64 1.64 0 0 1-.456-.986q-.067-.552.193-1.022.261-.47.774-.782.513-.315 1.21-.396.689-.08 1.256.11.572.184.933.582.366.398.43.95a1.63 1.63 0 0 1-.227 1.065q-.292.48-.82.666l.006.05a1.7 1.7 0 0 1 .793.237q.369.211.612.567.248.354.3.805.067.58-.222 1.079-.29.495-.861.827-.568.332-1.345.422m-.116-1q.402-.047.684-.218.28-.174.416-.446.135-.27.1-.6a1.1 1.1 0 0 0-.248-.584 1.2 1.2 0 0 0-.521-.361 1.5 1.5 0 0 0-.696-.072q-.386.045-.668.23-.285.185-.428.472a1.07 1.07 0 0 0-.097.624q.035.33.228.562.194.23.507.335.318.105.723.058m-.38-3.264q.33-.038.566-.2a1.02 1.02 0 0 0 .445-.985 1.03 1.03 0 0 0-.21-.521.95.95 0 0 0-.44-.314 1.3 1.3 0 0 0-.603-.061q-.339.039-.583.199a.96.96 0 0 0-.357.407q-.113.247-.073.554.033.312.203.533.175.217.446.324.274.102.606.064"
      fill="#2e220c"
    />
  </svg>
)

export const UploadIcon: React.FC = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.414 13.417a.417.417 0 0 1-.833 0V4.364l-3.469 3.18a.417.417 0 1 1-.563-.613L9.716 3.11a.417.417 0 0 1 .563 0l4.167 3.82a.417.417 0 0 1-.563.615l-3.469-3.18z"
      fill="#7d38d3"
    />
    <path
      d="M17.5 12.417a.417.417 0 1 0-.833 0v2.348c0 .375-.146.733-.4.995a1.33 1.33 0 0 1-.954.407H4.688c-.356 0-.7-.145-.954-.407-.255-.262-.4-.62-.4-.995v-2.348a.417.417 0 1 0-.834 0v2.348c0 .59.228 1.157.637 1.576s.967.659 1.55.659h10.625c.584 0 1.142-.238 1.551-.659a2.26 2.26 0 0 0 .637-1.576z"
      fill="#7d38d3"
    />
  </svg>
)

export const RefundIcon: React.FC = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.003 2.917A3.34 3.34 0 0 0 6.656 6.25a3.34 3.34 0 0 0 3.347 3.334 3.34 3.34 0 0 0 3.348-3.334 3.34 3.34 0 0 0-3.348-3.333m0 5.833c-1.382 0-2.515-1.125-2.515-2.5s1.133-2.5 2.515-2.5a2.51 2.51 0 0 1 2.515 2.5c0 1.384-1.124 2.5-2.515 2.5m6.795 2.925a1.576 1.576 0 0 0-1.99.2l-1.216 1.209s-.116.075-.283.141c-.083.025-.183.059-.291.084 0-.017.016-.034.025-.05.125-.259.166-.584.016-.892-.141-.3-.441-.517-.85-.642-1.598-.516-3.488-.666-5.362-.083H6.83l-.016.017-.708.316v-.116a.987.987 0 0 0-.991-.984h-1.2a.993.993 0 0 0-.998.984v4.658c0 .542.44.983.999.983h1.199c.483 0 .891-.35.974-.808.025 0 .042 0 .067-.017.15-.05.441-.066.883-.041.416.025.916.083 1.44.15l.208.025c.983.125 2.057.258 2.823.191.159-.016.3-.025.433-.033.383-.033.717-.058 1.025-.117.441-.083.866-.216 1.44-.5.525-.25 1.058-.675 1.524-1.125.467-.45.9-.941 1.241-1.358.566-.708.367-1.708-.366-2.192zM5.356 16.517a.24.24 0 0 1-.233.233H3.924a.24.24 0 0 1-.241-.233v-4.658c0-.134.108-.234.241-.234h1.2c.124 0 .232.1.232.234zm11.226-3.125c-.325.4-.733.867-1.183 1.292-.441.425-.907.791-1.332.991-.525.259-.883.367-1.24.434-.267.05-.542.075-.917.1-.141.016-.3.025-.475.041-.682.067-1.682-.058-2.706-.191l-.167-.017a22 22 0 0 0-1.49-.158c-.342-.017-.691-.017-.974.033V12.8l.999-.45c1.682-.525 3.397-.391 4.871.084.292.1.375.208.4.258s.033.125-.017.25a1.15 1.15 0 0 1-.316.367 1.1 1.1 0 0 1-.4.2h-1.09a.373.373 0 0 0-.375.375c0 .208.166.375.374.375h1.125c.274 0 .766-.059 1.224-.15a6 6 0 0 0 .666-.184c.192-.066.408-.166.55-.316l1.215-1.209a.84.84 0 0 1 1.05-.1c.391.259.474.759.2 1.092z"
      fill="#7d38d3"
    />
  </svg>
)

export const ChevronDownIcon: React.FC<{ isExpanded: boolean }> = ({ isExpanded }) => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: isExpanded ? 'rotate(180deg)' : 'none', transition: 'transform 0.3s ease' }}
  >
    <path d="M7 10L12 15L17 10" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
